import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AttachedFilesComponent } from './attached-files.component';
import { FileUploadService } from '@prlw/libs/file-upload/file-upload.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'prlw-attached-files',
  imports: [CommonModule, AttachedFilesComponent],
  templateUrl: './attached-files.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachedFilesContainer {
  constructor(private readonly fileUploadService: FileUploadService) {}

  attachedFiles$ = this.fileUploadService.attachedFiles$;

  eventRemoveAttachedFile(item: string) {
    this.fileUploadService.removeAttachedFile(item);
  }
}
